export const examAdminShell = {
  sectionLabel: "管理后台",
  brandSubtitle: "基于 AI 的能力测评管理后台",
  menu: {
    dashboard: "总览",
    staffUsers: "考务人员管理",
    candidateUsers: "考生管理",
    systemSettings: "系统管理",
    rolePermissions: "角色权限",
    customFields: "自定义字段",
    assetsCenter: "资产中心",
    auditLogs: "审计日志",
    auditLoginLogs: "登录日志",
    auditOperationLogs: "操作日志",
    questions: "题库中心",
    papers: "试卷中心",
    exams: "考试中心",
    execution: "夺旗环境管理",
    submissions: "代码提交记录",
    dockerImages: "镜像管理",
    dockerInstances: "实例管理",
    review: "阅卷中心",
    aiTasks: "AI 工作台",
  },
  breadcrumbs: {
    home: "管理后台",
    dashboard: "总览",
    staffUsers: "考务人员管理",
    candidateUsers: "考生管理",
    systemSettings: "系统管理",
    rolePermissions: "角色权限",
    customFields: "自定义字段",
    assetsCenter: "资产中心",
    auditLogs: "审计日志",
    auditLoginLogs: "登录日志",
    auditOperationLogs: "操作日志",
    questions: "题库中心",
    papers: "试卷中心",
    exams: "考试中心",
    execution: "夺旗环境管理",
    submissions: "代码提交记录",
    dockerImages: "镜像管理",
    dockerInstances: "实例管理",
    review: "阅卷中心",
    aiTasks: "AI 工作台",
  },
  routes: {
    businessGroup: "业务主链路",
    organizationGroup: "用户与组织",
    resourceGroup: "资源与环境",
    platformGroup: "系统与审计",
    userGroup: "用户管理",
    systemGroup: "系统管理",
    dockerGroup: "镜像与容器管理",
    auditAll: "全部日志",
    questionDetail: "题目详情",
    manualPaperPicker: "手工组选题工作台",
    paperDetail: "试卷详情",
    examDetail: "考试详情",
    attemptDetail: "作答详情",
    dockerInstanceDetail: "实例详情",
  },
  preferences: {
    entry: "个人偏好",
    title: "个人偏好",
    actions: {
      reset: "重置默认",
    },
    fields: {
      locale: "语言",
      navTheme: "导航主题",
      layout: "布局模式",
      contentWidth: "内容宽度",
      colorPrimary: "主题色",
      fixedHeader: "固定顶栏",
      fixSiderbar: "固定侧栏",
      splitMenus: "自动分栏菜单",
      colorWeak: "色弱模式",
    },
    options: {
      navThemeSystem: "跟随系统",
      navThemeLight: "浅色",
      navThemeDark: "深色",
      layoutMix: "混合",
      layoutSide: "侧边",
      layoutTop: "顶部",
      contentFluid: "自适应",
      contentFixed: "定宽",
    },
  },
};
